












































import {Component, Mixins, Prop} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import PopupHandlerMixin from '@/mixins/popupHandler'
import Assets from '@/mixins/Assets'
import IssuedInvoiceInfo from '@/components/IssuedInvoiceInfo.vue'
import FooterLayout from '@/components/Footer.vue'
import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import EmptyMessage from '@/components/EmptyMessage.vue'
import FooterButton from '@/components/FooterButton.vue'
import InvoiceDocumentPopup from '@/components/popup/InvoiceDocument.vue'
import BizRNumFormPopup from '@/components/popup/btt/BizRNumForm.vue'
import toCurrency from '@/filters/to-currency'
import {getBaseUrl, openNewWindow} from '@/utils'
import {namespace} from 'vuex-class'
import {ExternalInvoice, ExternalState, GetInvoiceDocumentRequest} from '@/store/modules/invoices/modules/external/types'

const externalInvoices = namespace('invoices/external')
const layout = namespace('layout')
const userAgent = namespace('userAgent')

@Component({
  components: {
    BizRNumFormPopup,
    FooterButton,
    MainLayout,
    IssuedInvoiceInfo,
    FooterLayout,
    HeaderLayout,
    EmptyMessage,
    InvoiceDocumentPopup,
  },
  filters: {
    toCurrency,
  },
})
export default class ExternalInvoicePage extends Mixins(Translation, PopupHandlerMixin, Assets) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: '', type: String}) invoiceId: string
  @Prop({default: 0, type: Number}) windowScrollY: number

  @layout.Mutation('updateError') updateError: (payload: {id: string, message: string}) => void
  @externalInvoices.State('invoice') invoice: ExternalInvoice
  @externalInvoices.Action('getInvoice') getInvoice: (payload: {invoiceId: string, registrationNumber: string}) => Promise<any>
  @externalInvoices.Action('getReview') getReview: (payload: GetInvoiceDocumentRequest) => Promise<string>
  @externalInvoices.Action('getInvoiceFile') getInvoiceFile: (payload: {invoiceId: string, registrationNumber: string}) => Promise<string>
  @externalInvoices.Mutation('update') update: (payload: ExternalState) => void
  @externalInvoices.Mutation('remove') remove: (payload: string) => void
  @userAgent.Getter('isMobile') isMobile: boolean

  loading: boolean = true
  isEmptyPage: boolean = false
  registrationNumber: string = ''
  invoiceDocumentData: string = ''

  get isVisibleFooter(): boolean {
    return !this.loading && !this.isEmptyPage
  }

  get amountTextColor(): string {
    return 'k-text-color-gray-900'
  }

  get keepLandingUrl(): string {
    return process.env.VUE_APP_LANDING_PAGE_URL || ''
  }

  created() {
    this.openPopup('bizRNumForm')
  }

  beforeRouteLeave(to, from, next) {
    this.remove('invoice')
    next()
  }

  onEnterRegistrationNumber(registrationNumber: string) {
    this.registrationNumber = registrationNumber
    this.loadInvoice()
  }

  loadInvoice() {
    return this.getInvoice({invoiceId: this.invoiceId, registrationNumber: this.registrationNumber})
      .then(() => {
        this.closePopup('bizRNumForm')
        this.loading = false
      })
      .catch((error) => {
        const {status} = error.response || {}
        if(status === 404) {
          this.isEmptyPage = true
          this.loading = false
        } else {
          this.updateError({
            id: 'get-invoice',
            message: `${this.ts('invoice')}를 가져오는데 ${this.ts('failed')}하였습니다.`,
          })
          throw error
        }
      })
  }

  openNewWindow(url, target) {
    openNewWindow(url, target)
  }

  openInvoiceDocument() {
    if(this.isMobile) {
      this.openPopup('invoiceDocument')
    } else {
      this.update({invoiceDocumentData: this.invoiceDocumentData, registrationNumber: this.registrationNumber})
      this.openNewWindow(`${getBaseUrl(location.href)}/external-document/${this.invoiceId}`, '_blank')
    }
  }

  onClickFooter() {
    const type = this.isMobile ? 'png' : 'html'
    this.getReview({invoiceId: this.invoiceId, registrationNumber: this.registrationNumber, type})
      .then((response) => {
        this.invoiceDocumentData = response
        this.openInvoiceDocument()
      })
      .catch((error) => {
        this.updateError({
          id: 'get-review',
          message: `${this.ts('invoice')} 문서를 가져오는데 ${this.ts('failed')}하였습니다.`,
        })
        throw error
      })
  }

  onClickDownload() {
    this.getInvoiceFile({invoiceId: this.invoiceId, registrationNumber: this.registrationNumber})
      .then((response) => {
        this.openNewWindow(response, '_self')
      })
      .catch((error) => {
        const {ts} = this
        this.updateError({
          id: 'get-file',
          message: `PDF를 ${ts('download')}하는데 ${ts('failed')}하였습니다.`,
        })
        throw error
      })
  }
}
